export const NAME = `proposals`;

export const BRIGHT_UID = 'cb6c91b7-e955-48b2-9fb0-3c1292701b63';
export const MORAL_PERSON_TYPE = 'company';
export const TYPE_PROPOSAL = 0;
